var map = {
	"./product-bh/products-day.json": [
		2473,
		473
	],
	"./product-en/products-day.json": [
		3814,
		814
	],
	"./product-kr/products-day.json": [
		7844,
		844
	],
	"./product-sc/products-day.json": [
		9217,
		217
	],
	"./product-tc/products-day.json": [
		9440,
		440
	],
	"./product-th/products-day.json": [
		7131,
		131
	],
	"./product-vn/products-day.json": [
		9487,
		487
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2508;
module.exports = webpackAsyncContext;